module.exports = __webpack_public_path__ + "img/gyant_brown_ba_list.ce99d702.jpg";